import axios from 'axios';

let config = {};

export const loadConfig = async () => {
  try {
    const response = await axios.get(`/config.json?timestamp=${new Date().getTime()}`);
    config = response.data;
  } catch (error) {
    console.error('Erro ao carregar a configuração:', error);
  }
};

export const getConfig = (key) => config[key];